import { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import {
  Avatar,
  Box,
  Checkbox,
  TextField,
  Button,
  CircularProgress,
} from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { yupResolver } from '@hookform/resolvers/yup';
import { CloseRounded, SearchRounded } from '@mui/icons-material';

import { HeaderDrawer, Text, Users } from './styles';

import { Input } from '../../../../components/Input';
import { LoadingBackdrop } from '../../../../components/LoadingBackdrop';

import {
  createFileRequest,
  Guest,
  updateFolderRequest,
} from '../../../../services';

import { stringAvatar } from '../../../../utils/avatarGenerator';

import useAuthStore from '../../../../store/auth';
import useCompanyStore from '../../../../store/companies';

interface drawerAddLinkProps {
  setOpenDrawerCreateLink: (type: boolean) => void;
  openDrawerCreateLink: boolean;
  listagemUsers: Guest[];
  listagemLink: any[];
  setListagemLink: (b: any[]) => void;
  isNew?: boolean;
  folderSelected?: any;
  setFolderSelected?: any;
  searchForUsers: string;
  loading: boolean;
  setSearchForUsers: (t: string) => void;
}

interface GuestToSelect extends Guest {
  selectedLink: boolean;
}

export default function DrawerAddLink({
  setOpenDrawerCreateLink,
  openDrawerCreateLink,
  listagemUsers,
  listagemLink,
  setListagemLink,
  isNew = false,
  folderSelected,
  setFolderSelected,
  searchForUsers,
  loading,
  setSearchForUsers,
}: drawerAddLinkProps) {
  const user = useAuthStore(state => state.user);
  const selectCompany = useCompanyStore(state => state.selectedCompany);

  const [listaConvidadosLinks, setListaConvidadosLinks] = useState<Guest[]>([]);
  const [listLinksUsers, setListLinkUsers] = useState<GuestToSelect[]>([]);
  const [listUsersFiltered, setListUsersFiltered] = useState<GuestToSelect[]>(
    [],
  );
  const [loadingBackdrop, setLoadingBackdrop] = useState(false);

  const formValidation = useCallback((): any => {
    return Yup.object().shape({
      name: Yup.string().min(3, 'O nome precisa ter no mínimo 3 caracteres'),
      link: Yup.string().required('O URL é obrigatório.'),
    });
  }, []);

  const { control, handleSubmit, reset } = useForm({
    resolver: yupResolver(formValidation()),
  });

  // useEffect(() => {
  //   if (listagemUsers?.length > 0) {
  //     const guests = listagemUsers.map((u: Guest) => ({
  //       ...u,
  //       profile: 'GS2',
  //       selectedFolder: false,
  //     }));

  //     const guestsWithoutOwner = guests?.filter(m => m.id !== user?.id);

  //     setListLinkUsers(guestsWithoutOwner as any);
  //   }
  // }, [listagemUsers]);

  // const handleUserToInviteLink = useCallback(
  //   (
  //     event: React.MouseEvent<unknown>,
  //     name: string,
  //     usr: GuestToSelect,
  //     idx: number,
  //     type: 'select',
  //   ) => {
  //     let listaUsuariosLinkEditada = { ...usr };

  //     if (type === 'select') {
  //       listaUsuariosLinkEditada.selectedLink = !usr?.selectedLink;
  //     }

  //     if (searchForUsers?.length > 0) {
  //       const listFilteredWhenSearching = listLinksUsers?.map(u => {
  //         if (u?.id === usr?.id) {
  //           setSearchForUsers('');
  //           return listaUsuariosLinkEditada;
  //         }
  //         return u;
  //       });
  //       const usuariosMembros = listFilteredWhenSearching?.filter(
  //         u => u.selectedLink,
  //       );
  //       setListaConvidadosLinks([...usuariosMembros!]);
  //       setListLinkUsers(listFilteredWhenSearching);
  //       setListUsersFiltered(listFilteredWhenSearching);
  //     } else {
  //       listLinksUsers?.splice(idx, 1, listaUsuariosLinkEditada);
  //       listUsersFiltered?.splice(idx, 1, listaUsuariosLinkEditada);
  //       setListUsersFiltered([...listUsersFiltered!]);
  //       setListLinkUsers([...listLinksUsers!]);
  //       const usuariosMembros = listLinksUsers?.filter(u => u.selectedLink);
  //       setListaConvidadosLinks([...usuariosMembros!]);
  //     }
  //   },
  //   [
  //     listLinksUsers,
  //     listUsersFiltered,
  //     searchForUsers?.length,
  //     setSearchForUsers,
  //   ],
  // );

  // useEffect(() => {
  //   const filterUser = listLinksUsers?.filter(users =>
  //     users.name.toUpperCase().includes(searchForUsers.toUpperCase()),
  //   );
  //   setListUsersFiltered(
  //     filterUser?.length > 0 ? filterUser : listUsersFiltered,
  //   );
  //   console.log({ filterUser });
  // }, [searchForUsers, openDrawerCreateLink]);

  const handleCreateLink = useCallback(
    async (formData: any) => {
      setLoadingBackdrop(true);
      try {
        const namesListFiltered = listagemLink.find(
          link => link.name === formData.name,
        );

        if (namesListFiltered) {
          toast.warning('Já existe um link com este nome');
        } else {
          const guests = listaConvidadosLinks?.map(m => ({
            id: m.id,
            name: m.name,
            email: m.email,
            profile: m.profile,
            status: m.status,
            avatar_url: m.avatar_url,
          }));

          const guests_ids = listaConvidadosLinks?.map(m => m.id);

          const data = {
            original_name: formData.name,
            mimetype: null,
            size: null,
            key: formData.link,
            is_downloaded: true,
            is_main: !isNew,
            is_public: true,
            url: formData.link,
            guests,
            guests_ids,
            folder_id: folderSelected?.id,
          };

          const fileResponse = await createFileRequest(
            data as any,
            user?.id as string,
            selectCompany?.id as string,
          );

          if (fileResponse?.status === 201) {
            const uploadedFile = {
              ...fileResponse?.data,
              type: 'link',
            };

            if (isNew && folderSelected) {
              const updatedFolder = {
                childrens: [...folderSelected.childrens, { ...uploadedFile }],
                childrens_ids: [
                  ...folderSelected.childrens_ids,
                  uploadedFile.id,
                ],
              };

              const respFolder = await updateFolderRequest(
                updatedFolder as any,
                folderSelected.id as string,
                user?.id as string,
                selectCompany?.id as string,
              );

              if (respFolder?.status === 200) {
                setFolderSelected({ ...respFolder?.data });
              }
            }

            setListagemLink([...listagemLink!, { ...uploadedFile }]);
            setOpenDrawerCreateLink(false);
            reset();
            toast.success('Link adicionado com sucesso');
          }
        }
      } catch (error) {
        console.log('Error handleCreateLink => ', error);
      } finally {
        setLoadingBackdrop(false);
      }
    },
    [
      listagemLink,
      listaConvidadosLinks,
      isNew,
      user?.id,
      selectCompany?.id,
      folderSelected,
      setListagemLink,
      setOpenDrawerCreateLink,
      reset,
      setFolderSelected,
    ],
  );

  return (
    <Box
      width="480px"
      padding="20px"
      display="flex"
      flexDirection="column"
      height="100%"
    >
      {loadingBackdrop && (
        <LoadingBackdrop
          text="Criando Link Externo"
          component=""
          loading={loadingBackdrop}
        />
      )}
      <HeaderDrawer>
        <CloseRounded
          sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
          onClick={() => setOpenDrawerCreateLink(false)}
        />
        <span className="title">Criar link</span>
      </HeaderDrawer>
      <Box display="flex" flexDirection="column" height="100%">
        <form
          onSubmit={handleSubmit(handleCreateLink)}
          style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
        >
          <Box display="flex" flexDirection="column" height="100%">
            <Box
              display="flex"
              flexDirection="column"
              height="100%"
              flex="1 0 0"
            >
              <Input
                label="Título ou descrição"
                name="name"
                control={control}
                placeholder="Título ou descrição"
                sx={{ marginTop: '30px' }}
                fullWidth
              />
              <Input
                label="Link externo"
                name="link"
                control={control}
                placeholder="Link externo"
                fullWidth
              />
            </Box>
            {/* {loading ? (
              <Box
                width="100%"
                display="flex"
                justifyContent="center"
                mt="20px"
              >
                <CircularProgress />
              </Box>
            ) : listUsersFiltered?.length > 0 ? (
              <>
                <Text>
                  <span className="desc">Compartilhamento</span>
                </Text>
                <TextField
                  variant="filled"
                  placeholder="Procurar membro..."
                  fullWidth
                  value={searchForUsers}
                  onChange={ev => setSearchForUsers(ev.target.value)}
                  InputProps={{
                    endAdornment: <SearchRounded />,
                  }}
                  sx={{ marginTop: '20px' }}
                />
                <Text
                  display="flex"
                  flexDirection="row"
                  width="100%"
                  justifyContent="space-between"
                  mt="20px"
                  mb="10px"
                >
                  <span className="desc">Nome</span>
                  <span className="desc">Remover</span>
                </Text>
                <Box>
                  {listUsersFiltered?.map((u, index) => (
                    <Users
                      onClick={event =>
                        handleUserToInviteLink(
                          event,
                          u.name,
                          u,
                          index,
                          'select',
                        )
                      }
                    >
                      <Box display="flex" flexDirection="row" gap="10px">
                        {u?.avatar_url ? (
                          <Avatar sx={{ width: '40px' }}>
                            <img
                              src={u?.avatar_url as string}
                              alt="Foto de perfil"
                              style={{ width: '100%' }}
                            />
                          </Avatar>
                        ) : (
                          <Avatar
                            {...stringAvatar(u.name!)}
                            sx={{ width: '40px' }}
                          />
                        )}
                        <span className="name">{u.name}</span>
                      </Box>
                      <Checkbox
                        color="primary"
                        checked={u.selectedLink === true}
                        sx={{ padding: '0' }}
                      />
                    </Users>
                  ))}
                </Box>
              </>
            ) : (
              <Box>Não há nenhum usuário convidado para adicionar</Box>
            )} */}
            <Box width="100%" display="flex" justifyContent="end" flex="0 0 0">
              <Button
                type="submit"
                variant="contained"
                color="success"
                sx={{
                  color: '#fff',
                  fontWeight: '500',
                  fontSize: '15px',
                  marginTop: '20px',
                }}
              >
                Salvar
              </Button>
            </Box>
          </Box>
        </form>
      </Box>
    </Box>
  );
}
